import React, {useState} from 'react';
import style from './styles.module.scss';
import {AppBar} from "@mui/material";
import logo from '~assets/OBS_ISO.png';
import Drawer from "../Drawer";
import i18next from 'i18next';

import {useAuth} from '../../../contexts/AuthContext';


const Navbar = () => {
    const {isAuthenticated, logout} = useAuth();

    const handleLogout = () => {
        logout();
        // Return to the public site so react-admin re-fetches anonymously (published-only).
        window.location.assign('/');
    };

    const [state, setState] = useState({
        searchExpanded: false,
        drawerOpen: false
    });

    const [currentLanguage, setCurrentLanguage] = useState(i18next.language || 'es');

    const changeLanguage = (lang: string) => {
        if (lang !== currentLanguage) {
            localStorage.setItem('language', lang);
            i18next.changeLanguage(lang);
            window.location.reload();
        }
    };

    const openDrawer = () => {
        setState({...state, drawerOpen: true});
    }

    const closeDrawer = () => {
        setState({...state, drawerOpen: false});
    }

    const {searchExpanded, drawerOpen} = state;

    return (
        <React.Fragment>
            <AppBar position={'fixed'} classes={{
                root: style.appBar
            }}
            sx={{
                zIndex: 2000
            }}>
                <div className={style.headerContainer}>
                    <a href="https://observatorio-infraestructura-as.org/">
                        <img className={style.logo} src={logo}/>
                    </a>
                    <span className={style.headerTitle}>
                        { i18next.t('navbar:title') }
                    </span>
                    <div className={style.languageSelector}>
                        <button
                            className={currentLanguage === 'es' ? style.languageActive : style.languageInactive}
                            onClick={() => changeLanguage('es')}
                        >
                            ES
                        </button>
                        <span className={style.languageSeparator}>|</span>
                        <button
                            className={currentLanguage === 'en' ? style.languageActive : style.languageInactive}
                            onClick={() => changeLanguage('en')}
                        >
                            EN
                        </button>
                        <span className={style.languageSeparator}>|</span>
                        <button
                            className={currentLanguage === 'pt' ? style.languageActive : style.languageInactive}
                            onClick={() => changeLanguage('pt')}
                        >
                            PT
                        </button>
                    </div>
                    {isAuthenticated && (
                        <button className={style.logoutButton} onClick={handleLogout}>
                            {i18next.t('navbar:logout')}
                        </button>
                    )}
                </div>
            </AppBar>
        </React.Fragment>
    );
}

export default Navbar;